import { useAuthStore } from '@/stores/authStore'
import { useUserContextStore } from '@/stores/userContextStore'

/**
 * Navigation guard that handles custom claims loading
 * Ensures user has RUBIX custom claims and permissions loaded
 * @param {RouteLocationNormalized} to - Target route
 * @param {RouteLocationNormalized} from - Current route
 * @returns {NavigationGuardReturn} Navigation result or undefined to proceed
 */
export async function requiresRubixClaim(to, from) {
  const authStore = useAuthStore()
  const userContextStore = useUserContextStore()

  const signedIn = await authStore.isUserSignedIn()

  if (signedIn) {
    await authStore.handleCustomClaims()

    try {
      if (!userContextStore.isPermissionLoaded) {
        await userContextStore.loadPermissions()
      }
    } catch (error) {
      // Permission loading failed - will be handled by requiresAppAccess
      console.error('Error loading permissions:', error)
    }
  }

  return undefined
}
